<template>
  <div>
    <div class="mt-1">

      <p class="text-start ms-4 text-secondary">Listado de Perfil</p>

      <!-- 🔍 BUSCADOR -->
      <div class="d-flex justify-content-end pe-4 mb-2">
        <div class="input-group" style="max-width: 320px;">
          <span class="input-group-text">
            <i class="bi bi-search"></i>
          </span>
          <input
            type="text"
            class="form-control"
            placeholder="Buscar perfil..."
            v-model="searchQuery"
            @input="Filtro" 
          />
        </div>
      </div>

      <div class="ps-4 table-responsive">
        
        <!-- 🔄 SPINNER -->
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2 text-secondary">Cargando información...</p>
        </div>

        <!-- TABLA -->
        <table v-else class="table mt-0 table-bordered tamañoLetra">
          <thead class="reducirTamaño">
            <tr class="text-nowrap text-white bg-solimano">
              <th class="sortable-th" @click="sortBy('idPerfil')" role="button" tabindex="0" @keydown.enter="sortBy('idPerfil')">ID<i class="bi ms-1" :class="sortIcon('idPerfil')"></i></th>
              <th class="sortable-th" @click="sortBy('perNombre')" role="button" tabindex="0" @keydown.enter="sortBy('perNombre')">PERFIL<i class="bi ms-1" :class="sortIcon('perNombre')"></i></th>
              <th class="sortable-th" @click="sortBy('audfecCreacion')" role="button" tabindex="0" @keydown.enter="sortBy('audfecCreacion')">CREACIÓN<i class="bi ms-1" :class="sortIcon('audfecCreacion')"></i></th>
              <th class="sortable-th" @click="sortBy('audfecActualizacion')" role="button" tabindex="0" @keydown.enter="sortBy('audfecActualizacion')">ACTUALIZACIÓN<i class="bi ms-1" :class="sortIcon('audfecActualizacion')"></i></th>
              <th><i class="bi bi-boxes fs-5"></i></th>
            </tr>
          </thead>

          <tbody class="text-nowrap text-center texto-fini align-middle">
            <tr
              class="reducirTamaño"
              v-for="lista in paginatedLista"
              :key="lista.idPerfil"
            >
              <td>{{ lista.idPerfil }}</td>
              <td class="text-start">{{ lista.perNombre }}</td>
              <td>{{ lista.audfechaCreacion }}</td>
              <td>{{ lista.audfechaActualizacion }}</td>

              <td class="py-1">

                <!-- EDITAR -->
                <button
                  @click="openEditModal(lista.idPerfil, lista.perNombre)"
                  class="btn btn-warning mx-1 py-0 px-2"
                >
                  <i class="bi bi-pencil text-white fs-5"></i>
                </button>

                <!-- ELIMINAR -->
                <button
                  @click="eliminarPerfil(lista)"
                  class="btn btn-light text-danger py-0 px-2"
                  title="Eliminar perfil"
                >
                  <i class="bi bi-trash3 fs-5"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        

      <div class="table-footer-bar">
        <div class="page-size-control">
          <label>Mostrar</label>
          <select v-model.number="itemsPerPage" @change="onPageSizeChange" class="form-select form-select-sm">
            <option v-for="size in pageSizeOptions" :key="size" :value="size">{{ size }}</option>
          </select>
          <span>registros</span>
        </div>
        <div class="record-count">{{ totalRows }} resultado(s)</div>
      </div>

      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-2">

        <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>

        <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
          <i class="bi bi-chevron-left"></i>
        </button>

        <span class="pagination-info small">
          Página {{ currentPage }} de {{ totalPages }}
        </span>

        <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-right"></i>
        </button>

        <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
          :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-double-right"></i>
        </button>

      </div>


        <!-- MODAL EDITAR -->
        <b-modal ref="editModal" centered title="Editar Perfil" hide-footer hide-close-button>
          <div>
            <label>Nombre del Perfil:</label>
            <input
              type="text"
              v-model="nombrePerfil"
              class="form-control mt-2"
            />
          </div>

          
          <b-button class="mt-3 mx-2" variant="primary" @click="saveChanges">
            Guardar
          </b-button>

          <b-button class="mt-3" variant="secondary" @click="closeEditModal">
            Cerrar
          </b-button>
        </b-modal>

      </div>
    </div>
  </div>
</template>


<script>
import tableUx from "@/mixins/tableUx";

import {mapGetters, mapActions} from 'vuex'
import Swal from "sweetalert";
import Swal2 from "sweetalert2";

export default {
  mixins: [tableUx],
  name: "PowerbyTablaPerfil",

  props: {
   
  },

  data() {
    return {
      itemsPerPage: 10,
      currentPage: 1,
      searchQuery: "",
      idPerfil: "",
      nombrePerfil: "",
      loading: false,
      idUsuario: null
    };
  },

  mounted() {
    this.idUsuario = localStorage.getItem("userId");

  },

  computed: {
    ...mapGetters('acciones' , ['ListaPerfil']),
    // Calcula el índice de inicio para la página actual
    listaFiltrada() {
      if (!this.searchQuery) return this.ListaPerfil;

      return this.ListaPerfil.filter((item) =>
        item.perNombre.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },

    // PAGINADO
    totalRows() { return this.listaFiltrada.length; },

    totalPages() {
      return Math.ceil(this.listaFiltrada.length / this.itemsPerPage);
    },

    paginatedLista() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.sortedRows(this.listaFiltrada).slice(start, start + this.itemsPerPage);
    }
  
  },

  created(){
  },

  methods: {

    ...mapActions("acciones" , ['ListarPerfil']),

    async eliminarPerfil(perfil) {
      const confirmacion = await Swal2.fire({
        icon: "warning",
        title: "¿Eliminar perfil?",
        text: `Se eliminará el perfil "${perfil.perNombre}".`,
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#dc3545",
      });
      if (!confirmacion.isConfirmed) return;

      try {
        await this.axios.delete(
          `BIClientes/EliminarPerfil?idPerfil=${encodeURIComponent(perfil.idPerfil)}`
        );
        await this.ListarPerfil();
        Swal2.fire("Perfil eliminado", "El perfil fue eliminado correctamente.", "success");
      } catch (error) {
        const mensaje =
          error.response?.data?.mensaje ||
          error.response?.data?.message ||
          "El perfil puede tener usuarios, categorías o permisos asociados.";
        Swal2.fire("No se pudo eliminar", mensaje, "error");
      }
    },

    openEditModal(idPerfil, nombre) {
      this.idPerfil = idPerfil;
      this.nombrePerfil = nombre;
      this.$refs.editModal.show();
    },

    closeEditModal() {
      this.idPerfil = "";
      this.nombrePerfil = "";
      this.$refs.editModal.hide();
    },

    saveChanges() {
      // Aquí puedes guardar el nombre editado y realizar otras operaciones necesarias
      // Luego, cierra el modal
      const from = {
        idUsuario: this.idUsuario,
        idPerfil: this.idPerfil,
        perNombre: this.nombrePerfil,
      };

      console.log(from);
      this.axios.put(`BIClientes/ModificarPerfil`, from).then((r) => {
        console.log(r.data);
        this.ListarPerfil()
        Swal(`Se realizo los cambios`, "", "success");
        this.closeEditModal();

      });
    },
   Filtro() {
      this.loading = true;
      setTimeout(() => {
        this.currentPage = 1;
        this.loading = false;
      }, 800);
    },

 
  },
};
</script>

<style scoped>
.b-modal .modal-header button.close {
  display: none;
}
.bg-solimano {
  text-align: center;
  background: #0080c8;
}

strong {
  font-size: 1.64rem;
  color: black;
}

.letra {
  font-weight: 600;
}

/* .icon-selector {
  display: flex;
  gap: 10px;
} */
.bg-iconos {
  background: #f7f7f7;
}

.icon-selector div {
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 2px;
}

.icon-selector div.selected {
  border-color: #007bff; /* Color de borde al seleccionar */
}

.icon-selector i {
  font-size: 24px; /* Tamaño de los iconos */
}

.tamañoLetra {
  font-size: 0.8rem;
}
.reducirTamaño {
  font-size: 0.65rem;
}
</style>
